import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class MatPaginatorI18nService extends MatPaginatorIntl {
  itemsPerPageLabel = 'Eléments par page';
  nextPageLabel = 'Page Suivante';
  previousPageLabel = 'Page Précedente';
  firstPageLabel = 'Première page';
  lastPageLabel = 'Dernière page';
  getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return ``;
    }
    const startIndex = page * pageSize;
    const endIndex = Math.min(startIndex + pageSize, length);
    return `${startIndex + 1} – ${endIndex} sur ${length}`;
  };
}
